import Vue from "vue";
import store from "./store";
import "./loadAssets";
import Rollbar from "rollbar";

if (window._rollbarConfig) {
  // _rollbarConfig は HTML Blade を参照
  Vue.prototype.$rollbar = new Rollbar({
    autoInstrument: true,
    accessToken: window._rollbarConfig.accessToken,
    captureUncaught: window._rollbarConfig.captureUnhandledRejections,
    captureUnhandledRejections:
      window._rollbarConfig.captureUnhandledRejections,
    addErrorContext: window._rollbarConfig.addErrorContext,
    reportLevel: window._rollbarConfig.reportLevel,
    payload: window._rollbarConfig.payload,
    ignoredMessages: window._rollbarConfig.ignoredMessages,
    checkIgnore: window._rollbarConfig.checkIgnore
  });

  Vue.config.errorHandler = (err, vm, info) => {
    console.log(`Captured in Vue.config.errorHandler: ${info}`, err);
    Vue.rollbar.error(err);
  };
}

new Vue({ store }).$mount("#app");
